import styled from "styled-components";
import { setPosition } from "../variables/utils";
import { COLOURS } from "../variables/colours";

export const LoadingWrapper = styled.div`
  ${setPosition({ position: "absolute", top: "0", left: "0", zIndex: 10 })};
  height: 100vh;
  width: 100%;
  overflow: hidden;
  ${props => !props.$isVisibile && `display: none;`};
`;

export const LoaderContainer = styled.div`
  background: ${COLOURS.primary.blue};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  ${props => props.customCss};
`;

export const LogoContainer = styled.div`
  align-items: center;
  bottom: 28%;
  display: flex;
  height: unset;
  justify-content: center;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 28%;
  width: unset;
`;

export const Spinner = styled.span`
  width: 84px;
  height: 84px;
  border-radius: 50%;
  position: absolute;
  animation: rotate 1s linear infinite;
  &::before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    border: 5px solid ${props => props.color || "white"};
    animation: dash 2s linear infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0%,
    100% {
      clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
    }
    25%,
    75% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
    }
    50% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
    }
  }
`;
